<template>
  <div
    class="details"
    :class="{ 'details--full': full, 'details--no-photo': !photo }"
    @click="$emit('click')"
  >
    <div
      v-if="photo"
      class="details__photo"
      :style="{ backgroundImage: `url(${ photo })` }"
    />
    <div class="details__inner">
      <span class="details__content details__content--name" v-html="name"/>
      <span class="details__content details__content--address" v-html="address"/>
    </div>
    <div v-if="isVideo" class="video-icon video-icon--full">
      <img src="/img/video.svg" alt="" class="video-icon__img">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    photo: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    full: {
      type: Boolean,
      default: false
    },
    isVideo: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  $details-width: 260px;

  .details {
    background-color: #ad1a1a;
    color: #fff;

    cursor: pointer;

    overflow: hidden;

    display: flex;
    flex-direction: column;

    width: 260px;
    height: 288px;

    @include media-up(xl) {
      width: $details-width + 30px;
      height: 315px;
    }

    &--full {
      width: 100%;

      box-shadow: 0px 12px 43.24px 2.76px rgba(0, 0, 0, 0.23);
    }

    &__photo {
      width: 100%;
      height: 152px;
      width: 100%;
      background-size: cover;
      background-position: 50% 50%;
    }

    &--full &__photo {
      @include media-up(xl) {
        height: 240px;
      }
    }

    &__inner {
      padding: 20px;

      background-image: url('/img/details-bg.png');
      background-size: cover;
      flex: 1;
      position: relative;
    }

    &__content {
      @include font($akrobat-font, 900);

      font-size: 12px;
      line-height: 1.25;
      letter-spacing: .4em;

      display: block;

      @include media-up(xl) {
        font-size: 16px;
      }

      &--name {
        text-transform: uppercase;
      }

      &--address {
        font-weight: 300;
        margin-top: 0.5em;

        @include media-up(xl) {
          font-size: 14px;
        }
      }
    }

    &--full {
      height: 315px;

      @include media-up(xl) {
        height: 436px;
      }
    }

    &--full &__inner {
      padding: 20px 20px 10px;
    }

    &--full &__content {
      font-size: 15px;

      @include media-up(xl) {
        font-size: 18px;
      }

      &--address {
        margin-top: 0.625em;
        margin-bottom: 1em;

        @include media-up(xl) {
          font-size: 16px;
        }
      }
    }

    &--no-photo {
      height: 288px - 152px;

      @include media-up(xl) {
        height: 315px - 152px;
      }
    }

    &--no-photo.details--full {
      height: 315px - 152px;

      @include media-up(xl) {
        height: 436px - 240px;
      }
    }
  }

  .video-icon {
    position: absolute;
    bottom: 12px;
    right: 12px;
    width: 24px;
    height: 24px;

    &__img {
      display: block;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Map/Details.vue